import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  selectPayments,
  selectPaymentsPagination,
  selectPaymentsFilter,
  fetchPaymentsActions,
  setPaymentsFilterAction,
  selectPaymentsFilterDateRange,
} from '../ducks';
import { PaymentList } from '../components';
import { apiCallIds as paymentApiCallIds } from '../api';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectToken } from '../../../features/auth/ducks';

const mapStateToProps = state => ({
  payments: selectPayments(state),
  pagination: selectPaymentsPagination(state),
  filter: selectPaymentsFilter(state),
  filterDateRange: selectPaymentsFilterDateRange(state),
  token: selectToken(state),
  isLoading: selectIsInProgress(state, paymentApiCallIds.FETCH_PAYMENTS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchPayments: fetchPaymentsActions.request,
      setFilter: setPaymentsFilterAction,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class PaymentListContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    payments: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { filter, actions } = this.props;
    actions.fetchPayments({
      ...filter,
    });
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.props.pagination.current = pagination.current;
    this.props.actions.fetchPayments({
      ...this.props.filter,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
    });
  };

  onFilterStatusChange = this.onFilterChange('status');

  onFilterDateRangeChange = ([dateFrom, dateTo]) => {
    const { filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      transferredAtStart: dateFrom ? dateFrom.startOf('day').toISOString() : null,
      transferredAtEnd: dateTo ? dateTo.endOf('day').toISOString() : null,
    });
  };

  render() {
    const { payments, pagination, filter, filterDateRange, isLoading, token } = this.props;

    return (
      <PaymentList
        payments={payments}
        pagination={pagination}
        filter={filter}
        onTableChange={this.handleTableChange}
        onFilterStatusChange={this.onFilterStatusChange}
        onFilterDateRangeChange={this.onFilterDateRangeChange}
        filterDateRange={filterDateRange}
        isLoading={isLoading}
        token={token}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/payment-management/containers/PaymentListContainer.js